import { SLATE_TEXT_FORMATS } from './const';

export const extractBankPlaceholders = (slateValue) => {
  const placeholders = {};
  let placeholderCounter = 0;

  const createPlaceholder = () => `<!#PH${++placeholderCounter}#!>`;

  const updatedValue = slateValue.map((paragraph) => {
    const updatedChildren = paragraph.children.map((node) => {
      if (node.type === SLATE_TEXT_FORMATS.BANK_MESSAGE) {
        const key = createPlaceholder();
        placeholders[key] = { type: SLATE_TEXT_FORMATS.BANK_MESSAGE, id: node.bankMessageId };
        return { text: key };
      } else if (node.type === SLATE_TEXT_FORMATS.PRODUCT_DESCRIPTION) {
        const key = createPlaceholder();
        placeholders[key] = {
          type: SLATE_TEXT_FORMATS.PRODUCT_DESCRIPTION,
          title: node.title,
          article: node.article,
        };
        return { text: key };
      }
      return node;
    });

    return {
      ...paragraph,
      children: updatedChildren,
    };
  });

  return { updatedValue, placeholders };
};
